import { ReactNode, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { APP_ROUTES_UNAUTHORIZE } from '../constants'
import { useProfile } from '../hooks'
import { useAccessSidebar } from '../hooks/useAccessSidebar'
import { isPermissionAllowedByModules } from '../modules/access'
import { useProductModules } from '../modules/useProductModules'

type ProtectedRouteProps = {
  children: ReactNode
  permissionKey: string | string[]
}
const ProtectedRoute = ({ children, permissionKey }: ProtectedRouteProps) => {
  const { profile, profileIsLoading } = useProfile({ isLoggedIn: true })
  const isValid = useAccessSidebar(permissionKey || '')
  const { enabledModules, bypassModuleGates, isSuperAdmin, productSku } = useProductModules()
  const moduleOk = isPermissionAllowedByModules(permissionKey, enabledModules, bypassModuleGates, productSku)
  const navigate = useNavigate()

  useEffect(() => {
    if (profileIsLoading || !profile) return
    // Role sidebar bypass for super_admin, but module preview (local SKU) still applies.
    if (isSuperAdmin && moduleOk) return
    if (isValid && moduleOk) return
    navigate(APP_ROUTES_UNAUTHORIZE, { replace: true })
  }, [isValid, moduleOk, isSuperAdmin, navigate, profile, profileIsLoading])

  if (profileIsLoading || !profile) {
    return null
  }

  if (isSuperAdmin && moduleOk) return <>{children}</>

  if (!isValid || !moduleOk) {
    return null
  }

  return <>{children}</>
}

export default ProtectedRoute
